<template>
 <div>
  <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px;">
    <el-col :lg="13" :md="24" :sm="24" :xl="12" :xs="24" style="margin-top: 5px;">
      <el-col :xl="14" :lg="14" :md="18" :sm="18" :xs="18">
        <el-cascader
          v-model="spaceIds"
          @change="spaceChange"
          :options="spaceList"
          change-on-select="true"
          placeholder="可选择多个空间"
          size="mini"
          :props="{multiple: true}"
          clearable
            style="padding-bottom: 5px; width: 90%">
        </el-cascader>
      </el-col>
      <el-col :xl="4" :lg="4" :md="18" :sm="18" :xs="18">
        <el-checkbox v-model="item.inverse">除选空间外</el-checkbox>
      </el-col>
    </el-col>

    <el-col :lg="9" :md="18" :sm="18" :xl="8" :xs="18" style="margin-top: 5px;">
      <el-select v-model="item.gatewaySn" size="mini" :placeholder="selectTisp" style="width: 90%;"
                 :disabled="showHide">
        <el-option
          v-for="item in gatewayList"
          :key="item.snCode"
          :label="item.name"
          :value="item.snCode">
        </el-option>
      </el-select>
    </el-col>
    <el-col :xl="1" :lg="2" :md="3" :sm="3" :xs="3" style="margin-top: 5px;">
      <el-button size="mini" style="color: red" @touchstart="deleteList"  @click="deleteList">-</el-button>
    </el-col>
  </el-col>
 </div>
</template>

<script>

export default {
  name: "NotificationObject",
  props:["item","index","deviceLinkageActions","spaceList","gatewayList"],
  data(){
    return{
      checked: false,
      spaceIds:[],
      showHide: false, //是否可编辑
      selectTisp: '请选择一个主机',
    }
  },

  created() {
    this.recursive([],{children:this.spaceList, id:'',label:''});
    if (this.spaceIds.length > 0){
      this.showHide = false;
      this.selectTisp = '请选择一个主机';
    }else{
      this.showHide = true;
      this.selectTisp = '请先选择全部空间';
    }
    // this.encapsulationSpceIds();
  },
  watch:{
  },
  methods:{
    spaceChange(val){
      let spaceIdList = [];
      if(val){
        if(val.length>0){
          for (var i = 0; i < val.length; i++){
            spaceIdList.push(val[i][val[i].length-1]);
          }
          this.showHide = false;
          this.selectTisp = '请选择一个主机';
        }else{
          this.showHide = true;
          this.item.gatewaySn = "";
          this.selectTisp = '请先选择空间';
        }
      }
      this.item.spaceIds = spaceIdList;
    },
    deleteList: function () {
      this.item.spaceIds = [];
      this.spaceIds = [];
      this.$emit('deleteIndex', this.index);
    },

    recursive(path, node){
      if(!node.children){
        //是否被选中 []
        if (this.item.spaceIds.indexOf(node.value) >= 0){
          this.spaceIds.push(path);
        }
      }else{
        node.children.forEach((child) =>{
          let list_path = [] ;
          for(var i = 0; i< path.length; i++){
            list_path.push(path[i]);
          }
          list_path.push(child.value)
          this.recursive(list_path, child)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
